<template>
  <el-dialog :center="center" :close-on-click-modal="closeOnClickModal" :width="dialogWidth" :visible="dialogVisible" top="8vh" @close="closeDialog">
    <template #title>
      <span class="el-dialog__title">项目截止日期</span>
    </template>
    <div class="backgroud-white cs-editor-content">
      <el-form key="form" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :rules="rules" :model="model" label-width="80px">
        <el-form-item label="项目名称" prop="ServiceItemName">
          <span>{{model.ServiceItemName}}</span>
        </el-form-item>
        <el-form-item label="时间范围">
          <span v-if="this.model.RangeLimitEnable">{{`${this.model.RangeLimitValue}${this.GLOBAL.enumSARangeLimitType.getDesc(this.model.RangeLimitType)}`}}</span>
        </el-form-item>
        <el-form-item label="开始日期" prop="StartDate">
          <el-date-picker size="small" format="yyyy/MM/dd" :disabled="readonly" v-model="model.StartDate" type="date" placeholder="选择开始日期" class="input-width" />
        </el-form-item>
        <el-form-item label="截止日期">
          <span v-if="!!calcEndDate">{{$moment(calcEndDate).format("YYYY/MM/DD")}}</span>
        </el-form-item>
      </el-form>
    </div>
    <template #footer>
      <div class="dialog-footer popup-footer">
        <el-row>
          <el-col>
            <el-button :disabled="readonly" type="primary" @click="saveChanges">保存更新</el-button>
          </el-col>
        </el-row>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { mixinDevice } from "@/core/mixin";

const mixin_generalMethods = {
  methods: {
    calculateEndDate() {
      if (!this.model.StartDate || !this.model.RangeLimitEnable) return null;

      let mStartDate = this.$moment(this.model.StartDate);

      let mEndDate = null;
      let rangeLimitValue = `${this.model.RangeLimitValue}`.toNumber();
      switch (this.model.RangeLimitType) {
        case this.GLOBAL.enumSARangeLimitType.Day:
          mEndDate = mStartDate.add(rangeLimitValue, "days");
          break;
        case this.GLOBAL.enumSARangeLimitType.Month:
          mEndDate = mStartDate.add(rangeLimitValue, "months");
          break;
        case this.GLOBAL.enumSARangeLimitType.Year:
          mEndDate = mStartDate.add(rangeLimitValue, "years");
          break;
      }

      return !!mEndDate ? mEndDate.toDate() : null;
    },
    validate() {
      let isValid = true;

      let refForm = this.$vueRefStore.getChildrenRef("form");
      if (!!refForm) {
        refForm.validate((valid) => {
          isValid = valid;
        });
      }

      return isValid;
    },
  },
};

const defaultData = {
  Id: 0,
  ServiceItemId: 0,
  ServiceItemName: null,
  ServiceType: 0,
  RangeLimitEnable: false,
  RangeLimitType: null,
  RangeLimitValue: null,
  CountLimitEnable: false,
  CountLimitType: null,
  CountLimitValue: null,
  TimeLimitEnable: false,
  TimeLimitType: null,
  TimeLimitValue: null,
  QuantityTotal: 0,
  QuantityAvailable: 0,
  CostAmountDiscounted: 0,
  SaleAmountDiscounted: 0,
  CostAmountUnit: 0,
  SaleAmountUnit: 0,
  CostAmountAvailable: 0,
  SaleAmountAvailable: 0,
  StartDate: null,
  EndDate: null,
  Status: 0,
  NonCourseServiceRecordList: [],
  QuantityType: 0,
};

export default {
  name: "serviceItemEndDateEditor",
  mixins: [mixinDevice, mixin_generalMethods],
  props: {
    center: {
      type: Boolean,
      default: true,
    },
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "700px",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {
        return Object.clone(defaultData);
      },
    },
  },
  data() {
    return {
      dialogVisible: false,
      rules: {
        StartDate: [
          {
            required: true,
            message: "请输入开始日期",
            trigger: "blur",
          },
        ],
      },
      model: Object.clone(defaultData),
    };
  },
  created() {
    this.dialogVisible = this.visible;

    this.reloadModelFromDataIn();
  },
  computed: {
    dialogWidth() {
      return !this.isMobile() ? this.width : "100%";
    },
    calcEndDate: function () {
      return this.calculateEndDate();
    },
  },
  methods: {
    reloadModelFromDataIn() {
      if (!this.dialogVisible) return;

      this.model = Object.clone(!!this.data ? this.data : defaultData);
      let refForm = this.$vueRefStore.getChildrenRef("form");
      if (!!refForm) {
        refForm.resetFields();
      }
    },
    closeDialog() {
      this.$emit("close");
    },
    saveChanges() {
      let isValid = this.validate();
      if (!isValid) return;

      this.model.EndDate = this.calculateEndDate();

      this.$emit("change", this.model);
    },
  },
  watch: {
    visible(newValue) {
      this.dialogVisible = newValue;

      if (this.visible) this.reloadModelFromDataIn();
    },
  },
};
</script>

<style lang="scss" scoped>
.cs-editor-content {
  padding: 0 15%;
  overflow-y: auto;

  .el-form-item {
    margin-bottom: 12px;

    .input-width {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/studyAbroad/serviceItem/serviceItemEndDateEditor.vue